import React from "react";
import { Radio } from "antd";
import { useHistory } from "react-router-dom";

export function AddReciptTabMenu(props) {
  let history = useHistory();

  const handleMenuChange = (e) => {
    history.push(`/stock-receipts/${e.target.value}`);
  };

  return (
    <div>
      <Radio.Group
        value={props.menu}
        onChange={handleMenuChange}
        style={{ marginBottom: 10 }}
      >
        <Radio.Button value="add" style={{ marginRight: 5 }}>
          Local Receipt
        </Radio.Button>
        {/* <Radio.Button value="grn" style={{ marginRight: 5 }}>
            GRN Details
          </Radio.Button> */}

        {/* <Radio.Button value="imported" style={{ marginRight: 5 }}>
          Imported Receipt
        </Radio.Button> */}
      </Radio.Group>
    </div>
  );
}
